import { DEPARTMENTS } from "../actions/utilities";

const INITIAL_STATE = {
    getDepartmentsLoading: false,
    getDepartmentsSuccess: false,
    getDepartmentsFailure: false,
    getDepartmentsError: null,

    getDepartmentsSelectListLoading: false,
    getDepartmentsSelectListSuccess: false,
    getDepartmentsSelectListFailure: false,
    getDepartmentsSelectListError: null,

    addDepartmentLoading: false,
    addDepartmentSuccess: false,
    addDepartmentFailure: false,
    addDepartmentError: null,

    deleteDepartmentLoading: false,
    deleteDepartmentSuccess: false,
    deleteDepartmentFailure: false,
    deleteDepartmentError: null,

    editDepartmentLoading: false,
    editDepartmentSuccess: false,
    editDepartmentFailure: false,
    editDepartmentError: null,
    departmentList: [],
    departmentsSelectList: []
}

const departmentReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case DEPARTMENTS.GET_ALL_DEPARTMENTS_REQUEST:
            return {
                ...state,
                getDepartmentsLoading: true,
                getDepartmentsSuccess: false,
                getDepartmentsFailure: false,
                getDepartmentsError: null
            }
        case DEPARTMENTS.GET_ALL_DEPARTMENTS_SUCCESS:
            return {
                ...state,
                getDepartmentsLoading: false,
                getDepartmentsSuccess: true,
                getDepartmentsFailure: false,
                getDepartmentsError: null,
                departmentList: action.payload
            }
        case DEPARTMENTS.GET_ALL_DEPARTMENTS_FAILURE:
            return {
                ...state,
                getDepartmentsLoading: false,
                getDepartmentsSuccess: false,
                getDepartmentsFailure: true,
                getDepartmentsError: action.payload,
            }
        case DEPARTMENTS.ADD_DEPARTMENT_REQUEST:
            return {
                ...state,
                addDepartmentLoading: true,
                addDepartmentSuccess: false,
                addDepartmentFailure: false,
                addDepartmentError: null
            }
        case DEPARTMENTS.ADD_DEPARTMENT_SUCCESS:
            let dept = state.departmentList;
            dept.push(action.payload);
            return {
                ...state,
                addDepartmentLoading: false,
                addDepartmentSuccess: true,
                addDepartmentFailure: false,
                addDepartmentError: null,
                departmentList: dept
            }
        case DEPARTMENTS.ADD_DEPARTMENT_FAILURE:
            return {
                ...state,
                addDepartmentLoading: false,
                addDepartmentSuccess: false,
                addDepartmentFailure: true,
                addDepartmentError: action.payload,
            }
        case DEPARTMENTS.DELETE_DEPARTMENT_REQUEST:
            return {
                ...state,
                deleteDepartmentLoading: true,
                deleteDepartmentSuccess: false,
                deleteDepartmentFailure: false,
                deleteDepartmentError: null
            }
        case DEPARTMENTS.DELETE_DEPARTMENT_SUCCESS:
            let dept_list = state.departmentList;
            dept_list.splice(action.info.index, 1);
            state.departmentList = dept_list;
            return {
                ...state,
                deleteDepartmentLoading: false,
                deleteDepartmentSuccess: true,
                deleteDepartmentFailure: false,
                deleteDepartmentError: null
            }
        case DEPARTMENTS.DELETE_DEPARTMENT_FAILURE:
            return {
                ...state,
                deleteDepartmentLoading: false,
                deleteDepartmentSuccess: false,
                deleteDepartmentFailure: true,
                deleteDepartmentError: action.payload,
            }
        case DEPARTMENTS.EDIT_DEPARTMENT_REQUEST:
            return {
                ...state,
                editDepartmentLoading: true,
                editDepartmentSuccess: false,
                editDepartmentFailure: false,
                editDepartmentError: null,
            }
        case DEPARTMENTS.EDIT_DEPARTMENT_SUCCESS:
            let tempDept = state.departmentList;
            // console.log('action.payload', action.payload);
            // console.log('action.payload', tempDept);
            for (var x = 0; x < tempDept.length; x++) {
                if (tempDept[x].deptId == action.payload.departmentId) {
                    tempDept[x] = action.payload;
                }
            }
            return {
                ...state,
                editDepartmentLoading: false,
                editDepartmentSuccess: true,
                editDepartmentFailure: false,
                editDepartmentError: null,
                departmentList: tempDept
            }
        case DEPARTMENTS.EDIT_DEPARTMENT_FAILURE:
            return {
                ...state,
                editDepartmentLoading: false,
                editDepartmentSuccess: false,
                editDepartmentFailure: true,
                editDepartmentError: action.payload,
            }



        //////
        case DEPARTMENTS.GET_DEPARTMENTS_SELECTLIST_REQUEST:
            return {
                ...state,
                getDepartmentsSelectListLoading: true,
                getDepartmentsSelectListSuccess: false,
                getDepartmentsSelectListFailure: false,
                getDepartmentsSelectListError: null,
                departmentsSelectList: []
            }
        case DEPARTMENTS.GET_DEPARTMENTS_SELECTLIST_SUCCESS:
            return {
                ...state,
                editDepartmentLoading: false,
                editDepartmentSuccess: true,
                editDepartmentFailure: false,
                editDepartmentError: null,
                departmentsSelectList: action.payload
            }
        case DEPARTMENTS.GET_DEPARTMENTS_SELECTLIST_FAILURE:
            return {
                ...state,
                getDepartmentsSelectListLoading: false,
                getDepartmentsSelectListSuccess: false,
                getDepartmentsSelectListFailure: true,
                getDepartmentsSelectListError: action.payload,
                departmentsSelectList: []
            }
        default:
            return state;
    }
}

export { departmentReducer };